// extracted by mini-css-extract-plugin
module.exports =  {"dataCards":"dataCards_X8RCtthX","dataCardsContainer":"dataCardsContainer_YsRmNhu1","dataCard":"dataCard_gaFHVcEU","value":"value_C_fEdqRx","comparison":"comparison_DGRQZnbZ"};